import React from "react";
import useBodyScrollLock from "../hooks/useBodyScrollLock";
import "./LoadingModal.css";

const LoadingModal = ({ isOpen, message = "Lade Daten..." }) => {
  useBodyScrollLock(Boolean(isOpen));
  if (!isOpen) return null;

  return (
    <div className="loading-modal-overlay">
      <div className="loading-modal">
        <div className="loading-spinner"></div>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default LoadingModal;
